import { Text } from '@oneaudi/unified-web-components';
import { PriceSectionStyle } from '~/app/pages/summary/dialogs/price-detail/components/price-section-style';
import { FootnoteReferenceNgc } from '~/components/footnotes/footnote-reference';
import { RegisterOrUpdateRateFootnoteForDialog } from '~/app/compositions/content/calculation-info/components/monthly-rate-footnote';

export function RateSection({
	title,
	price,
	bold,
}: {
	/* eslint-disable-next-line react/no-unused-prop-types */
	pricePartType: string;
	title: string;
	price: string | null | undefined;
	bold?: boolean;
}) {
	const footnoteReference = RegisterOrUpdateRateFootnoteForDialog();

	return (
		<PriceSectionStyle>
			<Text tag="p" variant={{ type: 'copy', order: '2', style: bold ? 'bold' : 'normal' }}>
				{title}
			</Text>
			<Text tag="p" variant={{ type: 'copy', order: '2', style: bold ? 'bold' : 'normal' }}>
				{price}
				{footnoteReference && <FootnoteReferenceNgc reference={footnoteReference} />}
			</Text>
		</PriceSectionStyle>
	);
}
